import { URL } from '../../../constants'
import { reduxToolkit } from '../../../helpers'


export const saveUtmParams = reduxToolkit('SAVE_UTM_PARAMS',
	(utm_param: string) => ({
		callPOST: `${URL}/v2/customer/utm/save`,
		queryData: { utm_param },
	}))
